/* eslint-disable max-len */
import React, { useContext } from "react"
import AddPatients from "./Patient_Details"
import { motion } from "framer-motion"
import { useState } from "react"
import TopHeader from "../../../components/TopHeader"
import { useSelector } from "react-redux"
import { faker } from "@faker-js/faker"
import { Link } from "react-router-dom"
import AnimatedModel from "../../../components/Animation/AnimatedModel"
import ConfirmationPrompt from "../../../components/ConfirmationPrompt"
import Loader from "../../../components/Loader"
import CustomOverLay from "../../../components/CustomOverLay"
import GlobalContext from "../../../components/Context/GloablContext"
import SearchEmptyScreen from "../../../components/SearchEmptyScreen"
import AddManageMoitoringCondTemplate from "../../ManageMonitoringConditionsTemplates/addTemplate"
import { validateEmail } from '../../../CommonMethods/EmailValidator'
import { useAddPatientMutation,useEditPatientMutation, useLazyGetMonitorAssociatedToPatientListQuery, useLazyGetObserversAssociatedToPatientListQuery,useLazyViewPatientQuery } from "../../../features/patientSlice"
import moment from "moment"
import { resetArrays as resetDeviceArray} from "../../../redux/MultiselectRowsConditionally"
import { useSearchParams,useLocation } from "react-router-dom"
import { useParams } from "react-router-dom"
import { useViewPatientQuery } from "../../../features/patientSlice"
import { useNavigate } from "react-router-dom"
import ChooseMonitoringTemplateTable from "./Components/MonitoringTemplateChooseTable"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useLazyGetMonitorViewTemplatesQuery } from "../../../features/monitorConditionTemplate"
import AdministrativeNotes from "./AdministrativeNotes"
import { useLazyGetProviderAssociatedToPatientListQuery } from "../../../features/patientSlice"
import MedicalNotes from "./MedicalNotes"
import ManageDevice from "../../ManageDevice"
import { handleEditMessageSent,handleTargetUserEditId } from "../../../redux/systemConfigSlice"
import { selectLinkedDevicesOfPatients } from "../../../redux/MultiselectRowsConditionally"
import { handleIsViewpatient } from "../../../redux/systemConfigSlice"
import { userService } from "../../../services/user.services"
import HelpGuideModal from "../../../components/HelpGuideModal"
import {useGetHelpGuideAdminQuery} from '../../../features/patientSlice'
import { swappedTimezoneMapping } from "../../../CommonMethods/TimeZoneDropdown/TimezoneForMapping"


export default function PatientIndex({edit}){
    const navigate=useNavigate()
    const {id} = useParams()
    const location = useLocation()
    const [searchParams,setSearchParams] = useSearchParams()
    const dispatch=useDispatch()
    const [isAnyFieldFilled,setIsAnyFieldFilled]=useState(false)
    const {data,isFetching,isLoading,isError,status}=useViewPatientQuery(id,{skip:!edit,refetchOnMountOrArgChange: true })
    const [patientTabName,setPatientTabName]= useState('patient')
    const [emptyArea,setEmptyArea]=useState(false);
    const {setToastmessage,setToastErrorMessage,isSideBar,editSocket,setEditSocket,sendMessageToStopEditing,sendMessageToStartEditing} = useContext(GlobalContext)
    const [textAreaMsg,setTextAreaMsg]=useState('')
    const [loadingStatus,setLoadingStatus]=useState(false)
    const [loading,setLoading]=useState(false)
    const [submitSelected,setSubmitSelected]=useState(false);
    const [confirmationState,setConfirmationState]=useState(false)
    const [confirmationStateCancel,setConfirmationStateCancel]=useState(false)
    const [emptyField, setEmptyField] = useState(false)
    const [isDisableCancel,setIsDisableCancel]=useState(true)
    const [templateId,setTemplateId] = useState('')
    const [isRadioChecked,setIsRadioChecked] = useState(false)
    const selectedPatientDeviceIds = useSelector(state => state?.MultiSelectSliceConditionally?.selectedRows?.selectedIds)
    const country_code=useSelector((state)=>state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
    const viewId=useSelector((state)=>state.systemConfigData.viewPatient)
    const [nextTarget, setNextTarget] = useState('');
    const [trigger,result] = useLazyViewPatientQuery()
  

    const [caseManagersContactDetails, setcaseManagersContactDetails] = useState([{
        case_manager_name: '',
        mobile_number: '',
      
    }]); 
      
    const [emergencyContactDetails, setEmergencyContactDetails] = useState([{
        emergency_contact_name: '',
        mobile_number: '',
    }]);

    const [providerTrigger,providerResult] = useLazyGetProviderAssociatedToPatientListQuery()

    const [observerTrigger,observerResult] = useLazyGetObserversAssociatedToPatientListQuery()
    
    const [addPatient] = useAddPatientMutation()
    const [editPatient]= useEditPatientMutation()
    const [dataloading,setDataLoading] = useState(true)
    const messageSent=useSelector(state=>state?.systemConfigData?.messageSent)
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState({"mobile_number":true,"main_number":true});
    const [addPatientDetails,setAddPatientBasicDetails]=useState({
        "user_name":"",
        "first_name":"",
        "middle_name":"",
        "last_name":"",
        "email_addr":"",
        "mobile_number":"",
        "main_number":"",
        "date_of_birth":"",
        "age":"",
        "gender":"Male",
        "address":"",
        "primary_identifier":"",
        "secondary_identifier":"",
        "onboarding_date":"",
        "number_of_readings":"0",
        "number_of_time_periods":"0",
        "time_period":"Day(s)",
        "weightKg":"",
        "weightlbs":"",
        "patient_status":[],
        "monitor_status":true,
        "monitor_cycle_start_date":"",
    })
    const [medicalNotes,setMedicalNotes]=useState({
        "medical_Notes":"",
    })

    const [administrativeNotes,setAdministrativeNotes]=useState({
        "administrative_Notes":"",
    })

    // timezone states starts
    const [selectedTimeZone,setSelectedTimezone]=useState('')
    const [isOpenTimeZone, setisOpenTimeZone] = useState(false);
    const [searchTimeZoneValue, setSearchTimeZoneValue] = useState('');
    const [timezones, setTimezones] = useState([]);
    const [filteredTimezones, setFilteredTimezones] = useState([]);
    const [timezoneHistory,setTimezoneHistory]=useState('');
    // timezone states end

    const [newCaseMangerCountycodes,setNewCaseMangerCountycodes]=useState([
    
        {
            mobile_number:country_code?.split('\t').join(''),
        }
    ])

    const [newCaseMangerValidCountrycode,setNewCaseMangerValidCountrycode]=useState([
    
        {
            mobile_number:true,
        }
    ])

    const [newEmergencyCountycodes,setNewEmergencyCountycodes]=useState([
    
        {
            mobile_number:country_code?.split('\t').join(''),
        }
    ])
    const [newEmergencyValidCountrycode,setNewEmergencyValidCountrycode]=useState([
    
        {
            mobile_number:true,
        }
    ])
    const unittype = useSelector(state => state.systemConfigData.vitalInfo.blood_glucose)
    const unittype1 = useSelector(state => state.systemConfigData.vitalInfo.blood_pressure)
    const unittype2 = useSelector(state => state.systemConfigData.vitalInfo.temperature)
    const unittype3 = useSelector(state => state.systemConfigData.vitalInfo.SP02)
    const unittype4 = useSelector(state => state.systemConfigData.vitalInfo.pulse)
    const unittype5 = useSelector(state => state.systemConfigData.vitalInfo.weight)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    
    
    useEffect(() => {
        if (edit) {
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-edit-patients');
            } else {
                setQueryParamsadmin('type=admin-edit-patients');
            }
        } else {
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-add-patients');
            } else {
                setQueryParamsadmin('type=admin-add-patients');
            }
        }
    }, [userType,edit]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    const [bloodGlucose, setBloodGlucose] = useState({
        startTimeMoniHourBG: '',
        startTimeMoniMinuteBG: '',
        frequency: '',
        time_period: 'Day(s)',
        maximumTimeDelayHourBG: '',
        maximumTimeDelayMinuteBG: '',
        lower_Threshold: '',
        upper_Threshold: '',
        isAMorPM: 'AM',
        unit:'',
    });

    const [bloodPressure, setBloodPressure] = useState({
        startTimeMoniHourBP: '',
        startTimeMoniMinuteBP: '',
        frequencyBP: '',
        time_periodBP: 'Day(s)',
        maximumTimeDelayHourBP: '',
        maximumTimeDelayMinuteBP: '',
        lower_Threshold_systolicBP: '',
        upper_Threshold_systolicBP: '',
        lower_Threshold_DiastolicBP: '',
        upper_Threshold_DiastolicBP: '',
        isAMorPMBP: 'AM',
        unit:'',
    });
    const [spo2, setSpo2] = useState({
        startTimeMoniHourSPO2: '',
        startTimeMoniMinuteSPO2: '',
        frequencySPO2: '',
        time_periodSPO2: 'Day(s)',
        maximumTimeDelayHourSPO2: '',
        maximumTimeDelayMinuteSPO2: '',
        lower_ThresholdSPO2: '',
        isAMorPMSPO2: 'AM',
        unit:'',
    });

    const [pulse, setPulse] = useState({
        startTimeMoniHourPulse: '',
        startTimeMoniMinutePulse: '',
        frequencyPulse: '',
        time_periodPulse: 'Day(s)',
        maximumTimeDelayHourPulse: '',
        maximumTimeDelayMinutePulse: '',
        lower_ThresholdPulse: '',
        upper_ThresholdPulse: '',
        isAMorPMPulse: 'AM',
        unit:'',
    });

    const [temprature, setTemprature] = useState({
        startTimeMoniHourTemp: '',
        startTimeMoniMinuteTemp: '',
        frequencyTemp: '',
        time_periodTemp: 'Day(s)',
        maximumTimeDelayHourTemp: '',
        maximumTimeDelayMinuteTemp: '',
        upper_ThresholdTemp: '',
        isAMorPMTemp: 'AM',
        unit:'',
    });

    const [weight, setWeight] = useState({
        startTimeMoniHourWeight: '',
        startTimeMoniMinuteWeight: '',
        frequencyWeight: '',
        time_periodWeight: 'Day(s)',
        maximumTimeDelayHourWeight: '',
        maximumTimeDelayMinuteWeight: '',
        lower_ThresholdWeight: '',
        upper_ThresholdWeight: '',
        isAMorPMWeight: 'AM',
        unit:'',
    });

    const [pageNumber,setPageNumber]= useState('page_number=1&limit=15')
    const [monitorTrigger,monitorResult] = useLazyGetMonitorAssociatedToPatientListQuery()
    const [countryCodeVal,setCountryCodeVal]=useState('')
    const [countryCodeVal2,setCountryCodeVal2]=useState('')
    const [isBGCheckboxChecked, setBGCheckboxChecked] = useState(false);
    const [isBPCheckboxChecked, setBPCheckboxChecked] = useState(false);
    const [isSPO2CheckboxChecked, setSPO2CheckboxChecked] = useState(false);
    const [isPulseCheckboxChecked, setPulseCheckboxChecked] = useState(false);
    const [isTempCheckboxChecked, setTempCheckboxChecked] = useState(false);
    const [isWeightCheckboxChecked, setWeightCheckboxChecked] = useState(false);
    const [chooseTemplate,setChooseTemplate] = useState(false)
    const [selectedRowIndex,setSelectedRowIndex] = useState('')
    const [changeAccess,setChangeAccess] = useState([])
    const [selectedSubdivReadings,setSelectedSubdivReadings] = useState({
        no_of_readings:"0",
        no_of_days:"0",
        time_period:"day(s)"
    })
    const [templateTrigger,templateResult,lastPromiseInfo ] = useLazyGetMonitorViewTemplatesQuery()

    const [emailError,setEmailError]=useState({
        "email_error":false,
        "username_error":false,
        "text":false
    })

    const [usernameError,setUsernameError]=useState(false)
    const [isSafari, setIsSafari] = useState(false);
    const [selectedOrganizationName, setSelectedOrganizationName] = useState({
        organization_name: '',
        organization_id: '',
    });
 
    const [selectedSubdivisionName, setSelectedSubdivisionName] = useState('')

    const [selectedSubdivisionId,setSelectedSubdivisionId] = useState('')
    
    const [changeProviderAccess,setChangeProviderAccess] = useState([])
    const [billingAgent,setBillingAgent] = useState([])
    const [sendAlert,setSendAlert] = useState([])
    const [providerSmsAlert,setProviderSmsAlert] = useState([])
    const [providerEmailAlert,setProviderEmailAlert] = useState([])
    const [providerMissedReading,setProviderMissedReading] = useState([])
    const [monitorSmsAlert,setMonitorSmsAlert] = useState([])
    const [monitorEmailAlert,setMonitorEmailAlert] = useState([])
    const [monitorMissedReading,setMonitorMissedReading] = useState([])
    const [observerSmsAlert,setObserverSmsAlert] = useState([])
    const [observerEmailAlert,setObserverEmailAlert] = useState([])
    const [observerMissedReading,setObserverMissedReading] = useState([])
    const [observerReadingReceived,setObserverReadingReceived] = useState([])
    // Patient alert states
    const [patientSmsAlert,setPatientSmsAlert] = useState(false)
    const [patientEmailAlert,setPatientEmailAlert] = useState(false)
    const [patientMissedReading,setPatientMissedReading] = useState(false)
    const [patientReadingReceived,setPatientReadingReceived] = useState(true)

    const handleConformationClick = () => {
        setEmptyArea(false)
        setConfirmationState(false);
    }
    const handleConformationClickCancel = () => {
        setEmptyArea(false)
        setConfirmationStateCancel(false);
    }
    
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number !==undefined? params.page_number= 1:''
        if (key === 'search') { params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params },{state:location.state})
    }
    const handleOnAddPatientbasicDetails=async()=>{
        setSubmitSelected(true)
        let isPatientAllfilled=true
        let templateAllfilled=true
        const hasEmptyFields = () => {
            let isFieldsEmpty=false
            if (
                addPatientDetails.user_name?.trim() === "" ||
                addPatientDetails.first_name?.trim() === "" ||
                addPatientDetails.last_name?.trim() === "" ||
                addPatientDetails.main_number?.trim() === "" ||
                addPatientDetails.primary_identifier?.trim() === "" ||
                addPatientDetails.date_of_birth === "" ||
                addPatientDetails.weightKg === "" ||
                addPatientDetails.weightlbs === "" || 
                addPatientDetails.patient_status.length === 0||
                addPatientDetails.number_of_readings===""||
                addPatientDetails.number_of_time_periods===""||
                (selectedOrganizationName?.organization_id==="")||
                (selectedSubdivisionId==="")||
                (edit&&addPatientDetails.email_addr?.trim() === "" ) ||
                selectedTimeZone.length === 0
            ) {
                isFieldsEmpty = true;
                isPatientAllfilled=false
            }
            if (isBGCheckboxChecked) {
                Object?.values(bloodGlucose).forEach((value) => {
                    if (value?.trim() === "") {
                        isFieldsEmpty = true;
                        templateAllfilled=false
                        return;
                    }
                });
            }

            // Check if BP checkbox is checked and its fields are empty
            if (isBPCheckboxChecked) {
                Object.values(bloodPressure).forEach((value) => {
                    if (value?.trim() === "") {
                        isFieldsEmpty = true;
                        templateAllfilled=false
                        return;
                    }
                });
            }

            // Check if SPO2 checkbox is checked and its fields are empty
            if (isSPO2CheckboxChecked) {
                Object.values(spo2).forEach((value) => {
                    if (value?.trim() === "") {
                        isFieldsEmpty = true;
                        templateAllfilled=false
                        return;
                    }
                });
            }
            // Check if Pulse checkbox is checked and its fields are empty
            if (isPulseCheckboxChecked) {
                Object.values(pulse).forEach((value) => {
                    if (value?.trim() === "") {
                        isFieldsEmpty = true;
                        templateAllfilled=false
                        return;
                    }
                });
            }
            // Check if Temprature checkbox is checked and its fields are empty
            if (isTempCheckboxChecked) {
                Object.values(temprature).forEach((value) => {
                    if (value?.trim() === "") {
                        isFieldsEmpty = true;
                        templateAllfilled=false
                        return;
                    }
                });
            }
            // Check if Temprature checkbox is checked and its fields are empty
            if (isWeightCheckboxChecked) {
                Object.values(weight).forEach((value) => {
                    if (value?.trim() === "") {
                        isFieldsEmpty = true;
                        templateAllfilled=false
                        return;
                    }
                });
            }

            return isFieldsEmpty;

        };

        if (hasEmptyFields()) {
            if(templateAllfilled&&!isPatientAllfilled){
                handleTabChange('patient')
            }else if(!templateAllfilled&&isPatientAllfilled){
                handleTabChange('monitoring_conditions')
            }
            setLoading(false)
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");

            return;

        }
        if (
            (parseInt(bloodGlucose.lower_Threshold) > parseInt(bloodGlucose.upper_Threshold)) ||
            (parseInt(bloodPressure.lower_Threshold_DiastolicBP) > parseInt(bloodPressure.upper_Threshold_DiastolicBP)) ||
            (parseInt(bloodPressure.lower_Threshold_systolicBP) > parseInt(bloodPressure.upper_Threshold_systolicBP)) ||
            (parseInt(pulse.lower_ThresholdPulse) > parseInt(pulse.upper_ThresholdPulse)) ||
            (parseInt(weight.lower_ThresholdWeight) > parseInt(weight.upper_ThresholdWeight))
        ){
            setToastErrorMessage("Lower Threshold cannot be greater than Upper Threshold");  
            return ;
        }

        if(validateEmail(addPatientDetails?.user_name?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "username_error":true,
                "text":true
            }))
           
            if(addPatientDetails?.email_addr?.trim()!==""&&validateEmail(addPatientDetails?.email_addr?.trim())) {  
                setEmailError((prev)=>({
                    ...prev,
                    "email_error":true,
                    "text":true
                }))
               
            }
            setLoading(false)
            // dispatch(handleIsAPICall(true))
            return
        }
        if(addPatientDetails?.email_addr?.trim()!==""&&validateEmail(addPatientDetails?.email_addr?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "email_error":true,
                "text":true
            }))
            setLoading(false);
            return
        }
        if(addPatientDetails?.email_addr?.trim()!==""&&validateEmail(addPatientDetails?.email_addr?.trim())) {  
            setEmailError((prev)=>({
                ...prev,
                "email_error":true,
                "text":true
            }))
            return
        }

        if ((!(isPhoneNumberValid.main_number)&&addPatientDetails?.main_number!=='') || (!(isPhoneNumberValid.mobile_number)&&addPatientDetails?.mobile_number!=='')) {
            // Delay showing the toast message until isPhoneNumberValid is updated
            setLoading(false);
            return;
        }
        function isphoneNumberValid(){
            const isValidPhone=newCaseMangerValidCountrycode?.some(field=>{return(field.mobile_number===false)})
            const isEmergencyValid=newEmergencyValidCountrycode?.some(field=>{return(field.mobile_number===false)})
            return isValidPhone||isEmergencyValid;
        } 

        if(isphoneNumberValid()){
            setLoading(false)
            return
        }

            setConfirmationState(true)

    }

    const handleFinalSubmit=async()=>{
        
        try {
            setLoading(true)
            let combinedStartTimeBG = `${bloodGlucose?.startTimeMoniHourBG?.padStart(2, '0')}:${bloodGlucose?.startTimeMoniMinuteBG?.padEnd(2, '0')} ${bloodGlucose?.isAMorPM}`;
            let maximumTimeDelayBG = `${bloodGlucose?.maximumTimeDelayHourBG?.padStart(2, '0')}:${bloodGlucose?.maximumTimeDelayMinuteBG?.padEnd(2, '0')}`;

            let combinedStartTimeBP = `${bloodPressure?.startTimeMoniHourBP?.padStart(2, '0')}:${bloodPressure?.startTimeMoniMinuteBP?.padEnd(2, '0')} ${bloodPressure?.isAMorPMBP}`;
            let maximumTimeDelayBP = `${bloodPressure?.maximumTimeDelayHourBP?.padStart(2, '0')}:${bloodPressure?.maximumTimeDelayMinuteBP?.padEnd(2, '0')}`;

            let combinedStartTimeSpo2 = `${spo2?.startTimeMoniHourSPO2?.padStart(2, '0')}:${spo2?.startTimeMoniMinuteSPO2?.padEnd(2, '0')} ${spo2?.isAMorPMSPO2}`;
            let maximumTimeDelaySpo2 = `${spo2?.maximumTimeDelayHourSPO2?.padStart(2, '0')}:${spo2?.maximumTimeDelayMinuteSPO2?.padEnd(2, '0')}`;

            let combinedStartTimePulse = `${pulse?.startTimeMoniHourPulse?.padStart(2, '0')}:${pulse?.startTimeMoniMinutePulse?.padEnd(2, '0')} ${pulse?.isAMorPMPulse}`;
            let maximumTimeDelayPulse = `${pulse?.maximumTimeDelayHourPulse?.padStart(2, '0')}:${pulse?.maximumTimeDelayMinutePulse?.padEnd(2, '0')}`;

            let combinedStartTimeTemprature = `${temprature?.startTimeMoniHourTemp?.padStart(2, '0')}:${temprature?.startTimeMoniMinuteTemp?.padEnd(2, '0')} ${temprature?.isAMorPMTemp}`;
            let maximumTimeDelayTemprature = `${temprature?.maximumTimeDelayHourTemp?.padStart(2, '0')}:${temprature?.maximumTimeDelayMinuteTemp?.padEnd(2, '0')}`;

            let combinedStartTimeWeight = `${weight?.startTimeMoniHourWeight?.padStart(2, '0')}:${weight?.startTimeMoniMinuteWeight?.padEnd(2, '0')} ${weight?.isAMorPMWeight}`;
            let maximumTimeDelayWeight = `${weight?.maximumTimeDelayHourWeight?.padStart(2, '0')}:${weight?.maximumTimeDelayMinuteWeight?.padEnd(2, '0')}`;
            
            const transformedCaseManagerData = caseManagersContactDetails
                .filter(case_manager => case_manager.case_manager_name || case_manager.mobile_number) // Filter out case_managers with missing data
                .map((case_manager, index) => ({
                    "uid":case_manager?.uid!==undefined?case_manager?.uid:faker.string.uuid(),
                    "name": case_manager.case_manager_name,
                    "country_code": "+" + (newCaseMangerCountycodes[index]?.mobile_number?.trim() || (country_code ? country_code.match(/\d+/)?.[0]?.trim() : "")),
                    "contact_number": case_manager.mobile_number
                }));
            const transformedEmergencyContact = emergencyContactDetails
                .filter(emergency_contact => emergency_contact.emergency_contact_name || emergency_contact.mobile_number) // Filter out contacts with missing data
                .map((emergency_contact, index) => ({
                    "uid":emergency_contact?.uid!==undefined?emergency_contact?.uid:faker.string.uuid(),
                    "name": emergency_contact.emergency_contact_name,
                    "country_code": "+" + (newEmergencyCountycodes[index]?.mobile_number?.trim() || (country_code ? country_code.match(/\d+/)?.[0]?.trim() : "")),
                    "contact_number": emergency_contact.mobile_number
                }));
           
            let notes = [];
            if (medicalNotes?.medical_Notes) {
                notes.push({
                    "note_type": "medical-note",
                    "description": medicalNotes.medical_Notes
                });
            }

            if (administrativeNotes?.administrative_Notes) {
                notes.push({
                    "note_type": "administrative-note",
                    "description": administrativeNotes.administrative_Notes
                });
            }

            const selectedKey = selectedTimeZone.split(':')[0];

            // Check if the key exists in the swappedTimezoneMapping
            const timezone = swappedTimezoneMapping[selectedKey] || selectedKey;
          
            let body = {
                "user_name": addPatientDetails.user_name?.trim().replace(/\s/g, ''),
                "first_name": addPatientDetails.first_name?.trim(),
                "middle_name": addPatientDetails.middle_name?.trim(),
                "last_name": addPatientDetails.last_name?.trim(),
                "mobile_number": addPatientDetails.mobile_number,
                "main_number": addPatientDetails.main_number,
                "country_code1": countryCodeVal ? "+" + countryCodeVal.split('\t').join('').trim() 
                    : (country_code ? "+" + country_code.split('\t').join('').trim() : ""),
                "country_code2": countryCodeVal2 ? "+" + countryCodeVal2.split('\t').join('').trim() 
                    : (country_code ? "+" + country_code.split('\t').join('').trim() : ""),

                // "country_code1": "+"+(countryCodeVal!==""?countryCodeVal.split('\t').join('')?.trim():country_code.split('\t').join('')?.trim()),
                // "country_code2": "+"+(countryCodeVal2!==""?countryCodeVal2.split('\t').join('')?.trim():country_code.split('\t').join('')?.trim()),
                "date_of_birth": addPatientDetails.date_of_birth !== "" ? moment(addPatientDetails.date_of_birth).format('YYYY-MM-DD') : '',
                "age": addPatientDetails.age,
                "gender": addPatientDetails.gender,
                "address": addPatientDetails.address,
                "primary_identifier": addPatientDetails.primary_identifier,
                "secondary_identifier": addPatientDetails.secondary_identifier,
                "onboarding_date": addPatientDetails.onboarding_date !== "" ? moment(addPatientDetails.onboarding_date).format('YYYY-MM-DD') : '',
                "weight_kgs": parseFloat(addPatientDetails.weightKg),
                "weight_lbs": parseFloat(addPatientDetails.weightlbs),
                "patient_status": addPatientDetails.patient_status,
                "monitoring_status": addPatientDetails?.monitor_status === true ? "Monitored" : "Not Monitored",
                "case_managers": transformedCaseManagerData ,
                "contacts": transformedEmergencyContact,
                "number_of_readings": parseInt(addPatientDetails.number_of_readings),
                "number_of_time_periods": parseInt(addPatientDetails.number_of_time_periods),
                "time_period": addPatientDetails.time_period,
                "timezone": timezone,
                "timezone_with_offset" : timezoneHistory.split(':')[0],
                // Patient alert fields
                "sms_alert": patientSmsAlert,
                "email_alert": patientEmailAlert,
                "missed_reading_alert": patientMissedReading,
                "reading_received_alert": patientReadingReceived,
                
            }
          
            if(!edit){
                body.notes=notes
            }
            if (edit) {
                // body.email_address = addPatientDetails.email_addr?.trim().replace(/\s/g, '');
                body.monitoring_cycle = (addPatientDetails.monitor_cycle_start_date !== ""&&addPatientDetails?.monitor_cycle_start_date!==undefined) ? moment(addPatientDetails.monitor_cycle_start_date).format('YYYY-MM-DD') : '';
                
                // Monitor users - combine permission changes and alert changes
                let monitorUsersArray = [];
                if(monitorResult?.data?.data?.length > 0){
                    monitorResult.data.data.forEach((monitor, index) => {
                        const monitorUserObj = {
                            user_id: monitor?.monitorUserData?.user_id,
                            permission: monitor?.monitor_permission,
                            user_name: monitor?.monitorUserData?.user_name,
                            sms_alert: monitor?.sms_alert === true,
                            email_alert: monitor?.email_alert === true,
                            missed_reading_alert: monitor?.missed_reading_alert === true
                        };
                        
                        const newMonitorUserObj = {};
                        let hasChanges = false;
                        
                        // Always include user_id, user_name, and permission when there are any changes
                        // Check for permission changes
                        if(changeAccess?.length > 0 && changeAccess[index] !== monitorUserObj.permission){
                            newMonitorUserObj.user_id = monitorUserObj.user_id;
                            newMonitorUserObj.user_name = monitorUserObj.user_name;
                            newMonitorUserObj.permission = changeAccess[index] === "monitor" ? "monitor" : "view";
                            hasChanges = true;
                        }
                        
                        // Check for alert changes
                        if(monitorSmsAlert?.length > 0 && monitorSmsAlert[index] !== monitorUserObj.sms_alert){
                            if(!hasChanges){
                                newMonitorUserObj.user_id = monitorUserObj.user_id;
                                newMonitorUserObj.user_name = monitorUserObj.user_name;
                                // Always include permission when updating alerts
                                newMonitorUserObj.permission = monitorUserObj.permission;
                            }
                            newMonitorUserObj.sms_alert = monitorSmsAlert[index];
                            hasChanges = true;
                        }
                        if(monitorEmailAlert?.length > 0 && monitorEmailAlert[index] !== monitorUserObj.email_alert){
                            if(!hasChanges){
                                newMonitorUserObj.user_id = monitorUserObj.user_id;
                                newMonitorUserObj.user_name = monitorUserObj.user_name;
                                // Always include permission when updating alerts
                                newMonitorUserObj.permission = monitorUserObj.permission;
                            }
                            newMonitorUserObj.email_alert = monitorEmailAlert[index];
                            hasChanges = true;
                        }
                        if(monitorMissedReading?.length > 0 && monitorMissedReading[index] !== monitorUserObj.missed_reading_alert){
                            if(!hasChanges){
                                newMonitorUserObj.user_id = monitorUserObj.user_id;
                                newMonitorUserObj.user_name = monitorUserObj.user_name;
                                // Always include permission when updating alerts
                                newMonitorUserObj.permission = monitorUserObj.permission;
                            }
                            newMonitorUserObj.missed_reading_alert = monitorMissedReading[index];
                            hasChanges = true;
                        }
                        
                        if(hasChanges && Object.keys(newMonitorUserObj).length > 2){
                            monitorUsersArray.push(newMonitorUserObj);
                        }
                    });
                }
                if(monitorUsersArray.length > 0){
                    body.users = monitorUsersArray;
                }
                
                // Provider users
                if(changeProviderAccess?.length>0 || providerSmsAlert?.length>0 || providerEmailAlert?.length>0 || providerMissedReading?.length>0){
                    let providerUsersArray = [];
                    if(providerResult?.data?.data?.length > 0){
                        providerResult.data.data.forEach((provider, index) => {
                            const providerUserObj = {
                                user_id: provider?.providerUserData?.user_id,
                                billing_agent: provider?.billing_agent !== undefined ? provider?.billing_agent : provider?.providerUserData?.billing_agent,
                                preference_mode: provider?.preference_mode || provider?.providerUserData?.preference_mode,
                                send_alert: provider?.send_alert !== undefined ? provider?.send_alert : provider?.providerUserData?.send_alert,
                                sms_alert: provider?.sms_alert === true,
                                email_alert: provider?.email_alert === true,
                                missed_reading_alert: provider?.missed_reading_alert === true,
                                user_name: provider?.providerUserData?.user_name
                            };
                            
                            const newProviderUserObj = {};
                            let hasChanges = false;
                            
                            // Always include user_id and user_name
                            newProviderUserObj.user_id = providerUserObj.user_id;
                            newProviderUserObj.user_name = providerUserObj.user_name;
                            
                            // Check for changes in each field
                            if(changeProviderAccess?.length > 0 && changeProviderAccess[index] !== providerUserObj.preference_mode){
                                newProviderUserObj.preference_mode = changeProviderAccess[index];
                                hasChanges = true;
                            }
                            if(billingAgent?.length > 0 && billingAgent[index] !== providerUserObj.billing_agent){
                                newProviderUserObj.billing_agent = billingAgent[index];
                                hasChanges = true;
                            }
                            if(sendAlert?.length > 0 && sendAlert[index] !== providerUserObj.send_alert){
                                newProviderUserObj.send_alert = sendAlert[index];
                                hasChanges = true;
                            }
                            if(providerSmsAlert?.length > 0 && providerSmsAlert[index] !== providerUserObj.sms_alert){
                                newProviderUserObj.sms_alert = providerSmsAlert[index];
                                hasChanges = true;
                            }
                            if(providerEmailAlert?.length > 0 && providerEmailAlert[index] !== providerUserObj.email_alert){
                                newProviderUserObj.email_alert = providerEmailAlert[index];
                                hasChanges = true;
                            }
                            if(providerMissedReading?.length > 0 && providerMissedReading[index] !== providerUserObj.missed_reading_alert){
                                newProviderUserObj.missed_reading_alert = providerMissedReading[index];
                                hasChanges = true;
                            }
                            
                            if(hasChanges && Object.keys(newProviderUserObj).length > 2){
                                providerUsersArray.push(newProviderUserObj);
                            }
                        });
                    }
                    if(providerUsersArray.length > 0){
                        body.providers = providerUsersArray;
                    }
                }
                
                // Observer users
                if(observerSmsAlert?.length>0 || observerEmailAlert?.length>0 || observerMissedReading?.length>0 || observerReadingReceived?.length>0){
                    let observerUsersArray = [];
                    if(observerResult?.data?.data?.length > 0){
                        observerResult.data.data.forEach((observer, index) => {
                            const observerUserObj = {
                                user_id: observer?.user_id,
                                sms_alert: observer?.sms_alert === true,
                                email_alert: observer?.email_alert === true,
                                missed_reading_alert: observer?.missed_reading_alert === true,
                                reading_received_alert: observer?.reading_received_alert === true,
                                user_name: observer?.user_name
                            };
                            
                            const newObserverUserObj = {};
                            let hasChanges = false;
                            
                            // Always include user_id (user_name is not needed/allowed)
                            newObserverUserObj.user_id = observerUserObj.user_id;
                            
                            // Check for alert changes
                            if(observerSmsAlert?.length > 0 && observerSmsAlert[index] !== observerUserObj.sms_alert){
                                newObserverUserObj.sms_alert = observerSmsAlert[index];
                                hasChanges = true;
                            }
                            if(observerEmailAlert?.length > 0 && observerEmailAlert[index] !== observerUserObj.email_alert){
                                newObserverUserObj.email_alert = observerEmailAlert[index];
                                hasChanges = true;
                            }
                            if(observerMissedReading?.length > 0 && observerMissedReading[index] !== observerUserObj.missed_reading_alert){
                                newObserverUserObj.missed_reading_alert = observerMissedReading[index];
                                hasChanges = true;
                            }
                            if(observerReadingReceived?.length > 0 && observerReadingReceived[index] !== observerUserObj.reading_received_alert){
                                newObserverUserObj.reading_received_alert = observerReadingReceived[index];
                                hasChanges = true;
                            }
                            
                            if(hasChanges && Object.keys(newObserverUserObj).length > 1){
                                observerUsersArray.push(newObserverUserObj);
                            }
                        });
                    }
                    if(observerUsersArray.length > 0){
                        body.observers = observerUsersArray;
                    }
                }
                if(selectedPatientDeviceIds?.length>0){
                    body.devices=selectedPatientDeviceIds?.map((device)=>device?.id)
                }else{
                    body.devices=[]
                }
                
            } else {
                body.email_address = addPatientDetails.user_name?.trim().replace(/\s/g, '');
            }
            
        
            selectedOrganizationName?.organization_id!==""?body.organization_id=selectedOrganizationName?.organization_id:""
            selectedOrganizationName?.organization_name!==""?body.organization_name=selectedOrganizationName?.organization_name:""
            selectedSubdivisionId!==""?body.subdivision_id=selectedSubdivisionId:""
            selectedSubdivisionName!==""?body.subdivision_name=selectedSubdivisionName:""
            
            body.monitoring_template= {}
        
            if (isBGCheckboxChecked) {
                body["monitoring_template"]["blood_glucose"] = {
                    "frequency_of_monitoring": bloodGlucose?.frequency,
                    "time_period": bloodGlucose?.time_period,
                    "start_time_of_monitoring": combinedStartTimeBG,
                    "maximum_time_delay": maximumTimeDelayBG,
                    "upper_threshold": bloodGlucose?.upper_Threshold,
                    "lower_threshold": bloodGlucose?.lower_Threshold,
                    "unit": (edit && bloodGlucose?.unit) ? bloodGlucose?.unit : unittype    
                };
            }

            if (isBPCheckboxChecked) {
                body["monitoring_template"]["blood_pressure"] = {
                    "frequency_of_monitoring": bloodPressure?.frequencyBP,
                    "time_period": bloodPressure?.time_periodBP,
                    "start_time_of_monitoring": combinedStartTimeBP,
                    "maximum_time_delay": maximumTimeDelayBP,
                    "upper_threshold_systolic": bloodPressure?.upper_Threshold_systolicBP,
                    "lower_threshold_systolic": bloodPressure?.lower_Threshold_systolicBP,
                    "upper_threshold_diastolic": bloodPressure?.upper_Threshold_DiastolicBP,
                    "lower_threshold_diastolic": bloodPressure?.lower_Threshold_DiastolicBP,
                    "unit": (edit && bloodPressure?.unit) ? bloodPressure?.unit : unittype1,
                };
            }

            if (isSPO2CheckboxChecked) {
                body["monitoring_template"]["spo2"] = {
                    "frequency_of_monitoring": spo2?.frequencySPO2,
                    "time_period": spo2?.time_periodSPO2,
                    "start_time_of_monitoring": combinedStartTimeSpo2,
                    "maximum_time_delay": maximumTimeDelaySpo2,
                    "lower_threshold": spo2?.lower_ThresholdSPO2,
                    "unit": (edit && spo2?.unit) ? spo2?.unit : unittype3,
                };
            }

            if (isPulseCheckboxChecked) {
                body["monitoring_template"]["pulse"] = {
                    "frequency_of_monitoring": pulse?.frequencyPulse,
                    "time_period": pulse?.time_periodPulse,
                    "start_time_of_monitoring": combinedStartTimePulse,
                    "maximum_time_delay": maximumTimeDelayPulse,
                    "upper_threshold": pulse?.upper_ThresholdPulse,
                    "lower_threshold": pulse?.lower_ThresholdPulse,
                    "unit":(edit && pulse?.unit) ? pulse?.unit : unittype4,
                };
            }

            if (isTempCheckboxChecked) {
                body["monitoring_template"]["temperature"] = {
                    "frequency_of_monitoring": temprature?.frequencyTemp,
                    "time_period": temprature?.time_periodTemp,
                    "start_time_of_monitoring": combinedStartTimeTemprature,
                    "maximum_time_delay": maximumTimeDelayTemprature,
                    "upper_threshold": temprature?.upper_ThresholdTemp,
                    "unit":(edit && temprature?.unit) ? temprature?.unit :unittype2,
                };
            }

            if (isWeightCheckboxChecked) {
                body["monitoring_template"]["weight"] = {
                    "frequency_of_monitoring": weight?.frequencyWeight,
                    "time_period": weight?.time_periodWeight,
                    "start_time_of_monitoring": combinedStartTimeWeight,
                    "maximum_time_delay": maximumTimeDelayWeight,
                    "upper_threshold": weight?.upper_ThresholdWeight,
                    "lower_threshold": weight?.lower_ThresholdWeight,
                    "unit":(edit && weight?.unit) ? weight?.unit :unittype5,
                };
            }
    
            if (edit) {
                const editRes = await editPatient({ id, body })
                //dispatch(handleIsAPICall(true))
                if (editRes?.error?.data?.message) {
                    setToastErrorMessage(editRes?.error?.data?.message)
                    setLoading(false)
                }
                else {
                    // For edit, preserve the original state (no need to reset page number)
                    navigate(`/manage-patients/${id}`,{state:[patientTabName]})
                    setToastmessage('Patient updated successfully');
                    setLoading(false)
                }
            }
            else{
            
                const addRes=await addPatient(body)
         
                if(addRes?.error?.data?.message){
                    setConfirmationState(false)
                    setToastErrorMessage(addRes?.error?.data?.message)
                    setLoading(false)
                    if(addRes?.error?.data?.message==="Username already exists. Please try another"){
                        setUsernameError(true)
                    }
                }
                else{
                    // Update the state to set page_number to 1 while preserving other pagination settings
                    const updatedState = {
                        ...location.state,
                        page_number: '1'
                    };
                    console.log('Original state:', location.state);
                    console.log('Updated state with page_number=1:', updatedState);
                    navigate(`/manage-patients/edit-patients/${addRes?.data?.user_id}`, { state: updatedState })
                    setToastmessage(addRes?.data?.message);
                    setLoading(false)
                }
            }
               
            
        } catch (error) {
            setLoading(false); 
            setToastErrorMessage(error.message)   
        }
    }

    const handleCancel = () => {
        setConfirmationStateCancel(false);
        // Clear form values
        setAddPatientBasicDetails({
            "user_name":"",
            "first_name":"",
            "middle_name":"",
            "last_name":"",
            "email_addr":"",
            "mobile_number":"",
            "main_number":"",
            "date_of_birth":"",
            "age":"",
            "gender":"",
            "address":"",
            "primary_identifier":"",
            "secondary_identifier":"",
            "onboarding_date":"",
            "weightKg":"",
            "weightlbs":"",
            "patient_status":[],
            "monitor_status":true,
        });
        if (nextTarget === 'view') {
            navigate(`/manage-patients/${viewId}`, { state:[patientTabName] });
        } else {
            navigate('/manage-patients', { state: location.state });
        }
    };
   
    // handle goback and cancel buton
    const handleCancelBottom = () => {
        const stateToPass = Array.isArray(location.state) ? '' : location.state;

        if (!isAnyFieldFilled && (viewId !== undefined && viewId !== "")) {
            navigate(`/manage-patients/${viewId}`, { state:[patientTabName] });
        } else if (!isAnyFieldFilled) {
            navigate('/manage-patients',{state:stateToPass});
        } else {
            setNextTarget(
                (viewId !== undefined && viewId !== "")
                    ? 'view'
                    : 'list'
            );
            setConfirmationStateCancel(true);
        }
    };

    const handleTabChange=(tabName)=>{        
        setChooseTemplate(false)
        if(edit){
            // Reset pagination to default values when changing tabs
            const currentParams = Object.fromEntries(searchParams);
            setSearchParams({
                ...currentParams,
                tab: tabName,
                page_number: 1,
                limit: 15
            });
        }
        setPatientTabName(tabName)
    }

    const handleFetchSubdivision = (item) => {
        setEmptyField(false);
        setSelectedOrganizationName((prevState) => ({
            ...prevState,
            organization_name: item.organization_name,
            organization_id: item.organization_id,
        }));
        setSelectedSubdivisionId('')
        setSelectedSubdivisionName('')
        // this is use for refresh the subdivision value

    }

    const handleSelectionSubdivision = async(item,orgId,fromuseeffect) => {
        setEmptyField(false);
        setSelectedSubdivisionName(item?.sub_division_name)
        setSelectedSubdivisionId(item?.subdivision_id)
        setSelectedSubdivReadings((prev)=>({
            ...prev,
            no_of_readings:(item?.number_of_readings!==null&&item?.number_of_readings!=='')?item?.number_of_readings:'0',
            no_of_days:(item?.number_of_time_periods!==null&&item?.number_of_time_periods!=='')?item?.number_of_time_periods:'0',
            time_period:(item?.time_period===''||item?.time_period===null)?'day(s)':item?.time_period?.toLowerCase()
        }))
      
        
    }

    // function for timezone selection
    const handleSelectionTimezone = (item) => {
        setSelectedTimezone(item);  // Set the selected timezone
        setTimezoneHistory(item); // for activity history purpose
        setisOpenTimeZone(false);   // Close the dropdown
        setSearchTimeZoneValue('');         // Clear the search input
        setFilteredTimezones(timezones);  // Reset the timezone list to the full list

    };

    useEffect(()=>{
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {
            
            editSocket.onmessage = async (event) => {
                if (hasLoggedOut) {
                    return; // Prevent multiple logout calls
                }else if (event.data === "logout") {
                    hasLoggedOut = true;
                    await userService.DuplicateLogout();
                    let arcm_trust_browser_token = localStorage.getItem('arcm_trust_browser_token')
                    let LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs')
                    localStorage.clear();
                    sessionStorage.clear();
                    localStorage.setItem("arcm_trust_browser_token",arcm_trust_browser_token)
                    localStorage.setItem("LogoutfromAllTabs",LogoutfromAllTabs)
                    localStorage.setItem('showLogoutToast', 'true');
                    setTimeout(() => {
                        window.location.reload();
                        navigate('/');
                    }, 500);
                }
            };
        }
    },[editSocket])

    useEffect(()=>{
        if(edit&&result!==undefined&&result?.data?.[0]?.patient_id!==undefined){
         
            dispatch(handleTargetUserEditId(result?.data?.[0]?.patient_id))

            setAddPatientBasicDetails((prev)=>({
                ...prev,
                "user_name":result?.data?.[0]?.user_name,
                "first_name":result?.data?.[0]?.first_name,
                "middle_name":result?.data?.[0]?.middle_name,
                "last_name":result?.data?.[0]?.last_name,
                "email_addr":result?.data?.[0]?.email_address,
                "mobile_number":result?.data?.[0]?.mobile_number,
                "main_number":result?.data?.[0]?.main_number,
                "date_of_birth":result?.data?.[0]?.date_of_birth,
                "age":result?.data?.[0]?.age,
                "gender":result?.data?.[0]?.gender,
                "address":result?.data?.[0]?.address,
                "primary_identifier":result?.data?.[0]?.primary_identifier,
                "secondary_identifier":result?.data?.[0]?.secondary_identifier,
                "onboarding_date":result?.data?.[0]?.onboarding_date,
                "weightKg":result?.data?.[0]?.weight_kgs,
                "weightlbs":result?.data?.[0]?.weight_lbs,
                "patient_status":result?.data?.[0]?.patient_status,
                "number_of_readings":result?.data?.[0]?.number_of_readings===""?"0":result?.data?.[0]?.number_of_readings,
                "number_of_time_periods":result?.data?.[0]?.number_of_time_periods===""?"0":result?.data?.[0]?.number_of_time_periods,
                "time_period":result?.data?.[0]?.time_period===""?'Day(s)':result?.data?.[0]?.time_period,
                "monitor_status":result?.data?.[0]?.monitoring_status==='Monitored' ? true : false,
                "monitor_cycle_start_date":result?.data?.[0]?.monitoring_cycle,
                "patient_id":result?.data?.[0]?.patient_id,
            }))
            setSelectedOrganizationName({
                "organization_id":result?.data?.[0]?.organization_id,
                "organization_name":result?.data?.[0]?.organization_name
            })
            result?.data?.[0]?.organization_id!==""&&result?.data?.[0]?.organization_id!==undefined&&handleFetchSubdivision({"organization_id":result?.data?.[0]?.organization_id,"organization_name":result?.data?.[0]?.organization_name})
            result?.data?.[0]?.organization_id!==""&&result?.data?.[0]?.organization_id!==undefined&&handleSelectionSubdivision({"subdivision_id":result?.data?.[0]?.subdivision_id,
                "sub_division_name":result?.data?.[0]?.subdivision_name,"number_of_readings":result?.data?.[0]?.defaultReadings?.number_of_readings===""?"0":result?.data?.[0]?.defaultReadings?.number_of_readings,"number_of_time_periods":result?.data?.[0]?.defaultReadings?.number_of_time_periods===""?"0":result?.data?.[0]?.defaultReadings?.number_of_time_periods,"time_period":result?.data?.[0]?.defaultReadings?.time_period},result?.data?.[0]?.organization_id,"fromuseeffect")
            
            // setting the states for the timezone from response
            let combinedTimezone= result?.data?.[0]?.timezone_with_offset ?`${result?.data?.[0]?.timezone_with_offset}: (${result?.data?.[0]?.abbreviation}) ${result?.data?.[0]?.utcoffset}`: '';
            setSelectedTimezone(combinedTimezone);
            setTimezoneHistory(`${result?.data?.[0]?.timezone_with_offset}`)
            // Initialize patient alert states from API response
            setPatientSmsAlert(result?.data?.[0]?.sms_alert === true)
            setPatientEmailAlert(result?.data?.[0]?.email_alert === true)
            setPatientMissedReading(result?.data?.[0]?.missed_reading_alert === true)
            setPatientReadingReceived(result?.data?.[0]?.reading_received_alert === true)
        }
        if(edit&&result?.data?.[0]?.deviceDetails?.length>0&&selectedPatientDeviceIds?.length===0){
            dispatch(selectLinkedDevicesOfPatients((result?.data[0]?.deviceDetails?.map((item)=>({id:item,name:'',status:''})))))
        }
        if(edit&&result?.data?.[0]?.monitoring_template!==undefined){
            let templateRes=result?.data?.[0]?.monitoring_template
            setBGCheckboxChecked(templateRes?.blood_glucose ? true : false);
            templateRes?.blood_glucose ? setBloodGlucose({
                startTimeMoniHourBG: templateRes?.blood_glucose?.start_time_of_monitoring?.split(':')[0],
                startTimeMoniMinuteBG: templateRes?.blood_glucose?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                frequency: templateRes?.blood_glucose?.frequency_of_monitoring,
                time_period: templateRes?.blood_glucose?.time_period,
                maximumTimeDelayHourBG: templateRes?.blood_glucose?.maximum_time_delay?.split(':')[0],
                maximumTimeDelayMinuteBG: templateRes?.blood_glucose?.maximum_time_delay?.split(':')[1],
                lower_Threshold: templateRes?.blood_glucose?.lower_threshold?.toString(),
                upper_Threshold: templateRes?.blood_glucose?.upper_threshold?.toString(),
                isAMorPM: templateRes?.blood_glucose?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                unit:templateRes?.blood_glucose?.unit,
            }) : ''

            setBPCheckboxChecked(templateRes?.blood_pressure ? true : false);

            templateRes?.blood_pressure ? setBloodPressure({
                startTimeMoniHourBP: templateRes?.blood_pressure?.start_time_of_monitoring?.split(':')[0],
                startTimeMoniMinuteBP: templateRes?.blood_pressure?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                frequencyBP: templateRes?.blood_pressure?.frequency_of_monitoring,
                time_periodBP: templateRes?.blood_pressure?.time_period,
                maximumTimeDelayHourBP: templateRes?.blood_pressure?.maximum_time_delay?.split(':')[0],
                maximumTimeDelayMinuteBP: templateRes?.blood_pressure?.maximum_time_delay?.split(':')[1],
                lower_Threshold_systolicBP: templateRes?.blood_pressure?.lower_threshold_systolic?.toString(),
                upper_Threshold_systolicBP: templateRes?.blood_pressure?.upper_threshold_systolic?.toString(),
                isAMorPMBP: templateRes?.blood_pressure?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                lower_Threshold_DiastolicBP: templateRes?.blood_pressure?.lower_threshold_diastolic?.toString(),
                upper_Threshold_DiastolicBP: templateRes?.blood_pressure?.upper_threshold_diastolic?.toString(),
                unit:templateRes?.blood_pressure?.unit,


            }) : ''
            setSPO2CheckboxChecked(templateRes?.spo2 ? true : false);

            templateRes?.spo2 ? setSpo2({
                startTimeMoniHourSPO2: templateRes?.spo2?.start_time_of_monitoring?.split(':')[0],
                startTimeMoniMinuteSPO2: templateRes?.spo2?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                frequencySPO2: templateRes?.spo2?.frequency_of_monitoring,
                time_periodSPO2: templateRes?.spo2?.time_period,
                maximumTimeDelayHourSPO2: templateRes?.spo2?.maximum_time_delay?.split(':')[0],
                maximumTimeDelayMinuteSPO2: templateRes?.spo2?.maximum_time_delay?.split(':')[1],
                lower_ThresholdSPO2: templateRes?.spo2?.lower_threshold?.toString(),
                isAMorPMSPO2: templateRes?.spo2?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                unit:templateRes?.spo2?.unit,

            }) : ''
            setPulseCheckboxChecked(templateRes?.pulse ? true : false);

            templateRes?.pulse ? setPulse({
                startTimeMoniHourPulse: templateRes?.pulse?.start_time_of_monitoring?.split(':')[0],
                startTimeMoniMinutePulse: templateRes?.pulse?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                frequencyPulse: templateRes?.pulse?.frequency_of_monitoring,
                time_periodPulse: templateRes?.pulse?.time_period,
                maximumTimeDelayHourPulse: templateRes?.pulse?.maximum_time_delay?.split(':')[0],
                maximumTimeDelayMinutePulse: templateRes?.pulse?.maximum_time_delay?.split(':')[1],
                lower_ThresholdPulse: templateRes?.pulse?.lower_threshold?.toString(),
                upper_ThresholdPulse: templateRes?.pulse?.upper_threshold?.toString(),
                isAMorPMPulse: templateRes?.pulse?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                unit:templateRes?.pulse?.unit,

            }) : ''
            setTempCheckboxChecked(templateRes?.temperature ? true : false);

            templateRes?.temperature ? setTemprature({
                startTimeMoniHourTemp: templateRes?.temperature?.start_time_of_monitoring?.split(':')[0],
                startTimeMoniMinuteTemp: templateRes?.temperature?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                frequencyTemp: templateRes?.temperature?.frequency_of_monitoring,
                time_periodTemp: templateRes?.temperature?.time_period,
                maximumTimeDelayHourTemp: templateRes?.temperature?.maximum_time_delay?.split(':')[0],
                maximumTimeDelayMinuteTemp: templateRes?.temperature?.maximum_time_delay?.split(':')[1],
                upper_ThresholdTemp: templateRes?.temperature?.upper_threshold?.toString(),
                isAMorPMTemp: templateRes?.temperature?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                unit:templateRes?.temperature?.unit,

            }) : ''
            setWeightCheckboxChecked(templateRes?.weight ? true : false);

            templateRes?.weight ? setWeight({
                startTimeMoniHourWeight: templateRes?.weight?.start_time_of_monitoring?.split(':')[0],
                startTimeMoniMinuteWeight: templateRes?.weight?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                frequencyWeight: templateRes?.weight?.frequency_of_monitoring,
                time_periodWeight: templateRes?.weight?.time_period,
                maximumTimeDelayHourWeight: templateRes?.weight?.maximum_time_delay?.split(':')[0],
                maximumTimeDelayMinuteWeight: templateRes?.weight?.maximum_time_delay?.split(':')[1],
                lower_ThresholdWeight: templateRes?.weight?.lower_threshold?.toString(),
                upper_ThresholdWeight: templateRes?.weight?.upper_threshold?.toString(),
                isAMorPMWeight: templateRes?.weight?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                unit:templateRes?.weight?.unit,

            }) : ''
        }
        if(edit){            
            setCountryCodeVal(result?.data?.[0]?.country_code1?.split('+')[1])
            setCountryCodeVal2(result?.data?.[0]?.country_code2?.split('+')[1])
            const caseManagerDetails=result?.data?.[0]?.case_managers?.length>0?result?.data?.[0]?.case_managers: [{}] ;
            setcaseManagersContactDetails(
                caseManagerDetails?.map((manager) => ({
                    case_manager_name: manager.name || '',
                    mobile_number: manager.contact_number || '',
                    uid:manager?.uid

                }))
            );
            setNewCaseMangerCountycodes(
                caseManagerDetails?.map((manager) => ({
                    mobile_number: manager.country_code?.replace('+', '')?.split('\t').join('') || '',
                }))
            );
            setNewCaseMangerValidCountrycode(
                caseManagerDetails?.map(() => ({
                    mobile_number: true,
                }))
            ); 

            const emergencyContactDetailsres=result?.data?.[0]?.contacts?.length>0?result?.data?.[0]?.contacts: [{}];
            setEmergencyContactDetails(
                emergencyContactDetailsres?.map((contact) => ({
                    emergency_contact_name: contact.name || '',
                    mobile_number: contact.contact_number || '',
                    uid:contact?.uid
                }))
            );
            setNewEmergencyCountycodes(
                emergencyContactDetailsres?.map((contact) => ({
                    mobile_number: contact.country_code?.replace('+', '')?.split('\t').join('') || '',
                }))
            );
            setNewEmergencyValidCountrycode(
                emergencyContactDetailsres?.map(() => ({
                    mobile_number: true,
                }))
            ); 
        }
        if(edit&&!messageSent&&editSocket&&result?.data?.[0]?.patient_id!==undefined){
               
            sendMessageToStartEditing(result?.data?.[0]?.patient_id)
            let message
            editSocket.onmessage = (event) =>{
                message = event.data
                if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                    setDataLoading(false)
                } else{
          
                    dispatch(handleEditMessageSent(false))
                    navigate('/manage-patients', { state: location.state })
                    { (JSON.parse(message)?.adminId) &&
                        setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this patient`)
                    }
                }
            }    
        }else{
            setDataLoading(false)
        }
        
        return(()=>{
            if((location?.state===null||location?.state==='')&&(result?.data?.[0]?.patient_id!==undefined)){
                sendMessageToStopEditing(result?.data?.[0]?.patient_id)
            }
        })
    },[edit,result,setWeight,setWeightCheckboxChecked,setBPCheckboxChecked,setBloodGlucose,setBloodGlucose,setTemprature,setTempCheckboxChecked,setPulseCheckboxChecked,setPulse,setSPO2CheckboxChecked,setSpo2,setBloodPressure])
   

    useEffect(()=>{
        setIsSafari(/^((?!chrome|firefox|android).)*safari/i.test(navigator.userAgent));
        return(()=>{
            dispatch(resetDeviceArray())
            dispatch(handleIsViewpatient(""))
            if(location?.state!==null||location?.state!==''){
                sendMessageToStopEditing()
            }
        })
    },[])

    useEffect(() => {
        if(templateResult?.status==='fulfilled'){
            setToastmessage('Template associated to the patient successfully')
            setSelectedRowIndex(templateId)
            setChooseTemplate(false)
        }else if(templateResult?.status==='rejected'){
            setToastErrorMessage('Template association to the patient failed')
            return;
        }
        if(templateResult?.status==='fulfilled'){
            setBGCheckboxChecked(templateResult?.data?.blood_glucose ? true : false);
            templateResult?.data?.blood_glucose ? setBloodGlucose({
                startTimeMoniHourBG: templateResult?.data?.blood_glucose?.start_time_of_monitoring?.split(':')[0],
                startTimeMoniMinuteBG: templateResult?.data?.blood_glucose?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                frequency: templateResult?.data?.blood_glucose?.frequency_of_monitoring,
                time_period: templateResult?.data?.blood_glucose?.time_period,
                maximumTimeDelayHourBG: templateResult?.data?.blood_glucose?.maximum_time_delay?.split(':')[0],
                maximumTimeDelayMinuteBG: templateResult?.data?.blood_glucose?.maximum_time_delay?.split(':')[1],
                lower_Threshold: templateResult?.data?.blood_glucose?.lower_threshold?.toString(),
                upper_Threshold: templateResult?.data?.blood_glucose?.upper_threshold?.toString(),
                isAMorPM: templateResult?.data?.blood_glucose?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                unit:templateResult?.data?.blood_glucose?.unit,

            }) : ''

            setBPCheckboxChecked(templateResult?.data?.blood_pressure ? true : false);

            templateResult?.data?.blood_pressure ? setBloodPressure({
                startTimeMoniHourBP: templateResult?.data?.blood_pressure?.start_time_of_monitoring?.split(':')[0],
                startTimeMoniMinuteBP: templateResult?.data?.blood_pressure?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                frequencyBP: templateResult?.data?.blood_pressure?.frequency_of_monitoring,
                time_periodBP: templateResult?.data?.blood_pressure?.time_period,
                maximumTimeDelayHourBP: templateResult?.data?.blood_pressure?.maximum_time_delay?.split(':')[0],
                maximumTimeDelayMinuteBP: templateResult?.data?.blood_pressure?.maximum_time_delay?.split(':')[1],
                lower_Threshold_systolicBP: templateResult?.data?.blood_pressure?.lower_threshold_systolic?.toString(),
                upper_Threshold_systolicBP: templateResult?.data?.blood_pressure?.upper_threshold_systolic?.toString(),
                isAMorPMBP: templateResult?.data?.blood_pressure?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                lower_Threshold_DiastolicBP: templateResult?.data?.blood_pressure?.lower_threshold_diastolic?.toString(),
                upper_Threshold_DiastolicBP: templateResult?.data?.blood_pressure?.upper_threshold_diastolic?.toString(),
                unit:templateResult?.data?.blood_pressure?.unit,


            }) : ''
            setSPO2CheckboxChecked(templateResult?.data?.spo2 ? true : false);

            templateResult?.data?.spo2 ? setSpo2({
                startTimeMoniHourSPO2: templateResult?.data?.spo2?.start_time_of_monitoring?.split(':')[0],
                startTimeMoniMinuteSPO2: templateResult?.data?.spo2?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                frequencySPO2: templateResult?.data?.spo2?.frequency_of_monitoring,
                time_periodSPO2: templateResult?.data?.spo2?.time_period,
                maximumTimeDelayHourSPO2: templateResult?.data?.spo2?.maximum_time_delay?.split(':')[0],
                maximumTimeDelayMinuteSPO2: templateResult?.data?.spo2?.maximum_time_delay?.split(':')[1],
                lower_ThresholdSPO2: templateResult?.data?.spo2?.lower_threshold?.toString(),
                isAMorPMSPO2: templateResult?.data?.spo2?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                unit:templateResult?.data?.spo2?.unit,

            }) : ''
            setPulseCheckboxChecked(templateResult?.data?.pulse ? true : false);

            templateResult?.data?.pulse ? setPulse({
                startTimeMoniHourPulse: templateResult?.data?.pulse?.start_time_of_monitoring?.split(':')[0],
                startTimeMoniMinutePulse: templateResult?.data?.pulse?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                frequencyPulse: templateResult?.data?.pulse?.frequency_of_monitoring,
                time_periodPulse: templateResult?.data?.pulse?.time_period,
                maximumTimeDelayHourPulse: templateResult?.data?.pulse?.maximum_time_delay?.split(':')[0],
                maximumTimeDelayMinutePulse: templateResult?.data?.pulse?.maximum_time_delay?.split(':')[1],
                lower_ThresholdPulse: templateResult?.data?.pulse?.lower_threshold?.toString(),
                upper_ThresholdPulse: templateResult?.data?.pulse?.upper_threshold?.toString(),
                isAMorPMPulse: templateResult?.data?.pulse?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                unit:templateResult?.data?.pulse?.unit,

            }) : ''
            setTempCheckboxChecked(templateResult?.data?.temperature ? true : false);

            templateResult?.data?.temperature ? setTemprature({
                startTimeMoniHourTemp: templateResult?.data?.temperature?.start_time_of_monitoring?.split(':')[0],
                startTimeMoniMinuteTemp: templateResult?.data?.temperature?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                frequencyTemp: templateResult?.data?.temperature?.frequency_of_monitoring,
                time_periodTemp: templateResult?.data?.temperature?.time_period,
                maximumTimeDelayHourTemp: templateResult?.data?.temperature?.maximum_time_delay?.split(':')[0],
                maximumTimeDelayMinuteTemp: templateResult?.data?.temperature?.maximum_time_delay?.split(':')[1],
                upper_ThresholdTemp: templateResult?.data?.temperature?.upper_threshold?.toString(),
                isAMorPMTemp: templateResult?.data?.temperature?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                unit:templateResult?.data?.temperature?.unit,

            }) : ''
            setWeightCheckboxChecked(templateResult?.data?.weight ? true : false);

            templateResult?.data?.weight ? setWeight({
                startTimeMoniHourWeight: templateResult?.data?.weight?.start_time_of_monitoring?.split(':')[0],
                startTimeMoniMinuteWeight: templateResult?.data?.weight?.start_time_of_monitoring?.split(':')[1]?.split(' ')[0],
                frequencyWeight: templateResult?.data?.weight?.frequency_of_monitoring,
                time_periodWeight: templateResult?.data?.weight?.time_period,
                maximumTimeDelayHourWeight: templateResult?.data?.weight?.maximum_time_delay?.split(':')[0],
                maximumTimeDelayMinuteWeight: templateResult?.data?.weight?.maximum_time_delay?.split(':')[1],
                lower_ThresholdWeight: templateResult?.data?.weight?.lower_threshold?.toString(),
                upper_ThresholdWeight: templateResult?.data?.weight?.upper_threshold?.toString(),
                isAMorPMWeight: templateResult?.data?.weight?.start_time_of_monitoring?.split(':')[1]?.split(' ')[1],
                unit:templateResult?.data?.weight?.unit,

            }) : ''
        }
     

    }, [templateResult])

    useEffect(() => {        
        if(edit&&!submitSelected&&searchParams?.get("tab")===null){
            searchParams?.get("tab")===null&&location?.state?.[3]!==null&&handleSearchParams("tab","patient")
            searchParams?.get("tab")===null||!(['patient','monitoring_conditions','device_details','administrative_notes','medical_notes']?.includes(searchParams?.get("tab")))?handleTabChange('patient'):handleTabChange(searchParams?.get("tab"))
            
        } 
        if(location.state&&location.state?.length===4){
            if(location?.state?.[1]==="FromView"){
                dispatch(handleIsViewpatient([location.state[2]]))
                handleSearchParams("tab",location?.state?.[3])
                setPatientTabName(location?.state?.[3])
            }
        }    
    }, [edit]); 

    useEffect(()=>{
        if(id){
            trigger(id)
        }
    },[id])




    return(
        <>
            
            <div  className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Patients"}/>
                {((edit&&(result?.isFetching||result?.isLoading||(result?.status!=='fulfilled'&&result?.status!=='rejected')))||loadingStatus||(dataloading))?<CustomOverLay Active text={`Loading Patient Details...`} classKey={`absolute top-0 left-0 z-50 overflowhidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:status==="rejected"?<SearchEmptyScreen text={"No data found"} />:<>
                    <div className='bg-white rounded-lg pb-[12px] pt-3.5 px-[24px] h-customh3'>
                        <motion.div 
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            <div className='bg-white'>
                                <div className='pr-6'>
                                    <div className='flex items-center mb-5'>
                                        <Link to="/manage-patients" state={location.state}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Patients</h1>
                                        </Link>
                                        {(viewId !== undefined && viewId!=="") &&<>
                                            <span className='mx-2'><img loading='lazy' decoding='async' src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                            <Link to={`/manage-patients/${viewId}`} state={[patientTabName]}>
                                                <h1 className="text-sm font-normal text-[#52555D]">View Patient</h1>
                                            </Link>
                                        </>}
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <h1 className="text-sm font-normal text-[#008586]">{`${edit?"Edit":"Add"} Patient`}</h1>
                                        {
                                            userType !=='super-admin' &&
                                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </span> 
                                        }
                                    </div>
                                    {(viewId !== undefined && viewId !== "") ?
                                        <Link to={`/manage-patients/${viewId}`} state={[patientTabName]} className=' items-center min-w-max flex'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] pl-3'>Go back to View Patient</span>
                                        </Link> 
                                        :    
                                        <div onClick={handleCancelBottom} className='cursor-pointer flex items-center'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                        </div>
                                    }
                                    <h1 className='text-xl font-normal text-[#000000] w-full text-center mt-[-23px]'>
                                        {`${edit?"Edit":"Add"} Patient`}
                                    </h1>
                                    <p className='text-end pt-2 pb-1'>‘*’ Indicates mandatory field</p>
                                </div>
                                <div className='mx-7'>
                                    <div className={`flex justify-between ${isSafari? 'pb-4' : 'pb-2'} overflow-x-auto overflow-y-hidden ${isSafari? 'scrollbar_purple' : 'scrollBar-hidden'} border-b border-[#E7CBD2] w-full mr-6`}>
                                        <button onClick={()=>{handleTabChange('patient')}} className={`px-2.5 pt-2.5 min-w-fit text-base font-semibold ${patientTabName==='patient'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='patient'?'patient_tab':''}`}>
                                            Patient Details
                                        </button>
                                        <button id={'monitor_tab'} data-testid={'monitoring_conditions'} onClick={()=>{handleTabChange('monitoring_conditions')}} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName==='monitoring_conditions'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='monitoring_conditions'?'patient_tab':''}`}>
                                            Monitoring Conditions
                                        </button>
                                        {edit&&<button id={"device_tab"} onClick={()=>{handleTabChange('device_details')}} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName==='device_details'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='device_details'?'patient_tab':''}`}>
                                            Device Details
                                        </button>}
                                        <button id={'administrative_notesTab'} onClick={()=>{handleTabChange('administrative_notes')}} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName==='administrative_notes'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='administrative_notes'?'patient_tab':''}`}>
                                            Administrative Notes
                                        </button>
                                        <button id={'medical_notesTab'} onClick={()=>{handleTabChange('medical_notes')}} className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName==='medical_notes'?'text-[#972E4C]':'text-[##030E06] '} relative ${patientTabName==='medical_notes'?'patient_tab':''}`}>
                                            Medical Notes
                                        </button>
                                    </div>
                                </div>
                                <div className="border border-[#C5C9DA] rounded-lg xl:pr-2 pr-1 mt-2.5 py-2">
                                    <div className='pl-6 2xl:pl-[57px] 2xl:pr-[42px] pr-4 py-5 overflow-auto overflow-x-hidden scrollbar_grayw6 h-customh19'>
                                        {((patientTabName==="patient"))&& <AddPatients 
                                            edit={edit}
                                            addPatientDetails={addPatientDetails}
                                            setAddPatientBasicDetails={setAddPatientBasicDetails}
                                            submitSelected={submitSelected}
                                            setSubmitSelected={setSubmitSelected}
                                            setAdministrativeNotes={setAdministrativeNotes}
                                            setMedicalNotes={setMedicalNotes}
                                            emptyField={emptyField}
                                            setIsDisableCancel={setIsDisableCancel}
                                            isPhoneNumberValid={isPhoneNumberValid}
                                            setIsPhoneNumberValid={setIsPhoneNumberValid}
                                            emergencyContactDetails={emergencyContactDetails}
                                            setEmergencyContactDetails={setEmergencyContactDetails}
                                            caseManagersContactDetails={caseManagersContactDetails}
                                            setcaseManagersContactDetails={setcaseManagersContactDetails}
                                            emailError={emailError}
                                            editPatient={editPatient}
                                            setEmailError={setEmailError}
                                            usernameError={usernameError}
                                            setUsernameError={setUsernameError}
                                            emptyArea={emptyArea}
                                            selectedSubdivReadings={selectedSubdivReadings}
                                            setSelectedSubdivReadings={setSelectedSubdivReadings}
                                            setEmptyArea={setEmptyArea}
                                            countryCodeVal={countryCodeVal}
                                            setCountryCodeVal={setCountryCodeVal}
                                            countryCodeVal2={countryCodeVal2}
                                            setCountryCodeVal2={setCountryCodeVal2}
                                            loading={loading}
                                            setLoading={setLoading}
                                            newCaseMangerCountycodes={newCaseMangerCountycodes}
                                            setNewCaseMangerCountycodes={setNewCaseMangerCountycodes}
                                            newCaseMangerValidCountrycode={newCaseMangerValidCountrycode}
                                            setNewCaseMangerValidCountrycode={setNewCaseMangerValidCountrycode}
                                            newEmergencyCountycodes={newEmergencyCountycodes}
                                            setNewEmergencyCountycodes={setNewEmergencyCountycodes}
                                            newEmergencyValidCountrycode={newEmergencyValidCountrycode}
                                            setNewEmergencyValidCountrycode={setNewEmergencyValidCountrycode}
                                            data={data}         
                                            selectedSubdivisionName={selectedSubdivisionName}
                                            setSelectedSubdivisionName={setSelectedSubdivisionName}
                                            setIsRadioChecked={setIsRadioChecked}                                           
                                            setIsAnyFieldFilled={setIsAnyFieldFilled}
                                            selectedOrganizationName={selectedOrganizationName}
                                            setSelectedOrganizationName={setSelectedOrganizationName}
                                            selectedSubdivisionId={selectedSubdivisionId}
                                            setSelectedSubdivisionId={setSelectedSubdivisionId}
                                            monitorTrigger={monitorTrigger}
                                            providerTrigger={providerTrigger}
                                            providerResult={providerResult}
                                            observerTrigger={observerTrigger}
                                            observerResult={observerResult}
                                            changeAccess={changeAccess}
                                            setChangeAccess={setChangeAccess}
                                            changeProviderAccess={changeProviderAccess}
                                            setChangeProviderAccess={setChangeProviderAccess}
                                            billingAgent={billingAgent}
                                            setBillingAgent={setBillingAgent}
                                            sendAlert={sendAlert}                                        
                                            setSendAlert={setSendAlert}
                                            monitorResult={monitorResult}
                                            setEmptyField={setEmptyField}
                                            
                                            // timezone field props
                                            isOpenTimeZone={isOpenTimeZone}
                                            setisOpenTimeZone={setisOpenTimeZone}
                                            selectedTimeZone={selectedTimeZone}
                                            setSelectedTimezone={setSelectedTimezone}
                                            handleSelectionTimezone={handleSelectionTimezone}
                                            setSearchTimeZoneValue={setSearchTimeZoneValue}
                                            searchTimeZoneValue={searchTimeZoneValue}
                                            timezones={timezones}
                                            setTimezones={setTimezones}
                                            filteredTimezones={filteredTimezones}
                                            setFilteredTimezones={setFilteredTimezones}
                                            // Patient alert props
                                            patientSmsAlert={patientSmsAlert}
                                            setPatientSmsAlert={setPatientSmsAlert}
                                            patientEmailAlert={patientEmailAlert}
                                            setPatientEmailAlert={setPatientEmailAlert}
                                            patientMissedReading={patientMissedReading}
                                            setPatientMissedReading={setPatientMissedReading}
                                            patientReadingReceived={patientReadingReceived}
                                            setPatientReadingReceived={setPatientReadingReceived}
                                            // Provider alert props
                                            providerSmsAlert={providerSmsAlert}
                                            setProviderSmsAlert={setProviderSmsAlert}
                                            providerEmailAlert={providerEmailAlert}
                                            setProviderEmailAlert={setProviderEmailAlert}
                                            providerMissedReading={providerMissedReading}
                                            setProviderMissedReading={setProviderMissedReading}
                                            // Monitor alert props
                                            monitorSmsAlert={monitorSmsAlert}
                                            setMonitorSmsAlert={setMonitorSmsAlert}
                                            monitorEmailAlert={monitorEmailAlert}
                                            setMonitorEmailAlert={setMonitorEmailAlert}
                                            monitorMissedReading={monitorMissedReading}
                                            setMonitorMissedReading={setMonitorMissedReading}
                                            // Observer alert props
                                            observerSmsAlert={observerSmsAlert}
                                            setObserverSmsAlert={setObserverSmsAlert}
                                            observerEmailAlert={observerEmailAlert}
                                            setObserverEmailAlert={setObserverEmailAlert}
                                            observerMissedReading={observerMissedReading}
                                            setObserverMissedReading={setObserverMissedReading}
                                            observerReadingReceived={observerReadingReceived}
                                            setObserverReadingReceived={setObserverReadingReceived}
                                        />

                                        }
                                        {((patientTabName==='monitoring_conditions'))&&chooseTemplate==false?<AddManageMoitoringCondTemplate
                                            edit={edit}
                                            setTemplateName={()=>{}}
                                            bloodGlucose={bloodGlucose}
                                            setBloodGlucose={setBloodGlucose}
                                            bloodPressure={bloodPressure}
                                            setBloodPressure={setBloodPressure}
                                            spo2={spo2}
                                            setSpo2={setSpo2}
                                            pulse={pulse}
                                            setPulse={setPulse}
                                            temprature={temprature}
                                            setTemprature={setTemprature}
                                            weight={weight}
                                            setSubmitSelected={setSubmitSelected}
                                            submitSelected={submitSelected}
                                            setWeight={setWeight}
                                            isBGCheckboxChecked={isBGCheckboxChecked}
                                            setBGCheckboxChecked={setBGCheckboxChecked}
                                            isBPCheckboxChecked={isBPCheckboxChecked}
                                            setBPCheckboxChecked={setBPCheckboxChecked}
                                            isSPO2CheckboxChecked={isSPO2CheckboxChecked}
                                            setSPO2CheckboxChecked={setSPO2CheckboxChecked}
                                            isPulseCheckboxChecked={isPulseCheckboxChecked}
                                            setPulseCheckboxChecked={setPulseCheckboxChecked}
                                            isTempCheckboxChecked={isTempCheckboxChecked}
                                            setTempCheckboxChecked={setTempCheckboxChecked}
                                            isWeightCheckboxChecked={isWeightCheckboxChecked}
                                            setWeightCheckboxChecked={setWeightCheckboxChecked}
                                            unittype={unittype}
                                            unittype1={unittype1}
                                            unittype2={unittype2}
                                            unittype3={unittype3}
                                            unittype4={unittype4}
                                            unittype5={unittype5}
                                            emptyField={emptyField}
                                            setEmptyField={setEmptyField}
                                            data={""}
                                            setIsAnyFieldFilled={setIsAnyFieldFilled}
                                            isDisableCanel={isDisableCancel}
                                            setIsDisableCancel={setIsDisableCancel}
                                            setChooseTemplate={setChooseTemplate}
                                            isPatient={true}

                                        />:chooseTemplate===true&&<ChooseMonitoringTemplateTable
                                            setChooseTemplate={setChooseTemplate}
                                            templateTrigger={templateTrigger}
                                            templateResult={templateResult}
                                            selectedRowIndex={selectedRowIndex}
                                            setTemplateId={setTemplateId}
                                            pageNumber={pageNumber}
                                            edit={edit}
                                            setPageNumber={setPageNumber}
                                            patient_id={data?.[0]?.patient_id}
                                            setSelectedRowIndex={setSelectedRowIndex}
                                            addPatient={true}
                                        />
                                        }
                                        {((patientTabName==='device_details'))&&<ManageDevice isPatient={true} patient_id={data[0]?.patient_id} setIsAnyFieldFilled={setIsAnyFieldFilled}/>

                                        }
                                        {((patientTabName==='administrative_notes'))&&<AdministrativeNotes 
                                            administrativeNotes={administrativeNotes}
                                            setIsAnyFieldFilled={setIsAnyFieldFilled}
                                            setAdministrativeNotes={setAdministrativeNotes}
                                            addPatientDetails={addPatientDetails}
                                            handleTabChange={handleTabChange}
                                            setEmptyField={setEmptyField}
                                            emptyField={emptyField}
                                            edit={edit}
                                            patient_id={data?.[0]?.patient_id}

                                        />
                                        }
                                        {((patientTabName==='medical_notes'))&&
                                        <MedicalNotes
                                            medicalNotes={medicalNotes}
                                            setMedicalNotes={setMedicalNotes}
                                            setIsAnyFieldFilled={setIsAnyFieldFilled}
                                            edit={edit}
                                            addPatientDetails={addPatientDetails}
                                            handleTabChange={handleTabChange}
                                            setEmptyField={setEmptyField}
                                            emptyField={emptyField}
                                            patient_id={data?.[0]?.patient_id}

                                        />
                                        }
                                    </div>
                                </div>
                                <div className='flex justify-end'>
                                    <button
                                        type="button"
                                        id="cancel"
                                        onClick={() => handleCancelBottom()}
                                        className={`px-4 py-2.5 text-lg font-semibold text-[#972E4C] rounded-[16px] mt-2.5 w-[148px]
    border border-[#972E4C] `}
                                    >
                                        Cancel
                                    </button>
                                    <button type='button'
                                        id="update"
                                        data-testid={"add_patient"}
                                        onClick={handleOnAddPatientbasicDetails}
                                        className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px] ml-4
                            bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                        {edit? "Update" : "Submit"} 
                                    </button>
                                </div>
                            </div>
                        </motion.div>
                    </div>

                </>}
                {confirmationState && 
                <AnimatedModel 
                    Children={
                        <ConfirmationPrompt
                            emptyField={emptyArea}
                            setEmptyField={setEmptyArea}
                            setTextAreaMsg={setTextAreaMsg}
                            textAreaMsg={""}
                            handleOnCLickActivate={handleFinalSubmit}
                            handleClose={handleConformationClick}
                            tittle= {`${edit ? "Update" : "Add"} Patient`}
                            message = {`Are you sure you want to ${edit ? "update" : "add"} this patient?`}
                            textMessage = {true===false?false:true}
                            buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}                                
                            CancelButton={'No'}
                            disabled={loading}
                        />
                    }
                /> 
                }
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                    <HelpGuideModal
                        setHelpGuideModel={setHelpGuideModel}
                        pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                    />
                }
                {confirmationStateCancel && 
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            emptyField={emptyArea}
                            setEmptyField={setEmptyArea}
                            handleOnCLickActivate={handleCancel}
                            handleClose={handleConformationClickCancel}
                            tittle={'Cancel'}
                            message={`Are you sure you want to cancel ${edit? "updating" : "adding"} this patient?`}
                            textMessage = {true===false?false:true}
                            buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}                                
                            CancelButton={'No'}
                        />
                    }
                /> 
                }
                
            </div>
        </>
    )
}